import { render, staticRenderFns } from "./AdvertisementApply.vue?vue&type=template&id=2b2436cc&scoped=true&"
import script from "./AdvertisementApply.vue?vue&type=script&lang=js&"
export * from "./AdvertisementApply.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementApply.vue?vue&type=style&index=0&id=2b2436cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2436cc",
  null
  
)

export default component.exports